/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : RATINGS MANAGER : STYLES --------------- ++++++++++ */
export default theme => ({
    ratingsmanager: {
        '& .title':{
            '& h2':{
                fontSize: pxToEm(24),
                fontWeight: 'bold',
                marginBottom: pxToEm(15)
            }
        },
        '& .name-page-copy': {
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        '& .name-ratingscontrols': {
            position: 'relative',
            zIndex: '1',
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.2s',
            marginBottom: pxToEm(56),
            justifyContent: 'space-between',
            '& .name-controls': {
                '& .control': {
                    fontSize: pxToEm(14)
                },
                '& .button': {
                    marginLeft: pxToEm(16),
                    width: pxToEm(124),
                    height: pxToEm(40)
                }
            },
            '& .name-sites': {
                display: 'flex',
                alignItems: 'center',
                '& .fieldlabel': {
                    fontSize: pxToEm(14),
                    fontWeight: '500',
                    marginRight: pxToEm(15)
                }
            }
        }
    },
    [mediaQuery.medium]:{
        ratingsmanager: {

        }
    }
});
